// Meta (Facebook) Pixel — consent-gated loader + event helpers.
// Events queue in the fbq stub; the network script only loads after cookie consent.

const CONSENT_KEY = 'reshapers_cookie_consent';
export const CONSENT_ACCEPTED_EVENT = 'reshapers-consent-accepted';

let pixelId = null;
let scriptLoaded = false;

const hasConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY) === 'accepted'; } catch { return false; }
};

const ensureStub = () => {
  if (window.fbq) return;
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
};

const injectScript = () => {
  if (scriptLoaded) return;
  scriptLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
};

export const initFbPixel = (id) => {
  if (!id || pixelId) return;
  pixelId = id;
  ensureStub();
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
  if (hasConsent()) {
    injectScript();
  } else {
    window.addEventListener(CONSENT_ACCEPTED_EVENT, injectScript, { once: true });
  }
};

export const fbTrack = (event, params = {}, eventID = null) => {
  if (!pixelId || !window.fbq) return;
  if (eventID) {
    window.fbq('track', event, params, { eventID });
  } else {
    window.fbq('track', event, params);
  }
};

export const fbPageView = () => {
  if (!pixelId || !window.fbq) return;
  window.fbq('track', 'PageView');
};

// Parse "XCG 25.00" style display amounts into { value, currency }
export const parseAmount = (display) => {
  const m = String(display || '').match(/([A-Z]{2,4})?\s*([\d.,]+)/);
  if (!m) return null;
  const value = parseFloat(m[2].replace(',', ''));
  if (isNaN(value)) return null;
  return { value, currency: m[1] || 'XCG' };
};
